"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _memoize = _interopRequireDefault(require("transmute/memoize"));

function areKeysEqual(map1, map2) {
  var map1KeySet = map1.keySeq().toSet();
  var map2KeySet = map2.keySeq().toSet();
  return map1KeySet.equals(map2KeySet);
}

var associationsAddedOrRemoved = (0, _memoize.default)(function (associationsMap1, associationsMap2) {
  if (!areKeysEqual(associationsMap1, associationsMap2)) {
    return true;
  }

  var associationObjectTypes = associationsMap1.keySeq().toSet();
  return associationObjectTypes.reduce(function (isNotEqual, objectType) {
    if (isNotEqual) {
      return true;
    }

    var associationIdSet1 = associationsMap1.get(objectType).keySeq().toSet();
    var associationIdSet2 = associationsMap2.get(objectType).keySeq().toSet();
    return !associationIdSet1.equals(associationIdSet2);
  }, false);
});
var _default = associationsAddedOrRemoved;
exports.default = _default;
module.exports = exports.default;